import Api from '../../api'
import axios from '@/js/api'
import { MessageBox } from 'element-ui'
import router from '../../router'
let authCode;

const state = {
	dynamicValidateForm: {
		UserName: "",
		Password: "",
		RoleId: '',
		Answer: '',
		Captcha: '',
	},
	codeImg: '',
	selectRole: [],
	passwordChecked: true,
	menuFlag: true,
	links: [],
	permissions: '',
	openeds: [],
	selectRoleList: {}
};
const getters = {

};
const mutations = {
	SetCaptcha(state, arr) {
		state.codeImg = 'data:' + arr.data.ContentType + ';base64,' + arr.data.Image;
		state.dynamicValidateForm.Captcha = arr.data.EncodeCode
	},
	setEnableRoles(state, arr) {
		console.log(arr)
		// if(arr.data.Roles.length==1){
		//     state.dynamicValidateForm.RoleId=arr.data.Roles[0].RoleGuid;
		//     state.selectRole=[]
		// }else{
		state.selectRoleList = arr.data;

		// let array = arr.data.Roles.filter(item => item.RoleName !== "仲裁专家");
		state.selectRole = arr.data.Roles;
		localStorage.setItem('selectRole', JSON.stringify(arr.data.Roles));
		// }
	},
	setEnableRolesList(state, arr) {
		state.selectRole = arr;
	},
	setMenuFlag(state, arr) {
		state.menuFlag = arr;
	},
	setLinks(state, arr) {
		state.links = arr;
		localStorage.setItem('links', JSON.stringify(arr));
	},
	changeRouter(state, permissions) {
		state.menuFlag = false;
		state.openeds.push(permissions.KeyName)
		if (permissions[0].children.length > 0) {
			state.permissions = permissions[0].children[0].RoutePath;
			// router.push({path:'.'+permissions[0].children[0].RoutePath})
			router.push({ path: permissions[0].children[0].RoutePath })
		} else {
			state.permissions = permissions[0].RoutePath;
			// router.push({path:'.'+permissions[0].RoutePath})
			router.push({ path: permissions[0].RoutePath })
		}
	}
};
const actions = {
	GetCaptcha({ commit }) {
		localStorage.removeItem('Version');
		authCode = parseInt(Math.random() * (99999999 - 111 + 1) + 111, 10);
		axios.ajaxGet('get', Api.api.login.GetCaptcha, { t: authCode }).then(res => {
			commit('SetCaptcha', res)
		})
	},
	GetEnableRoles({ commit, state, dispatch }) {
		return axios.ajaxGet('get', Api.api.login.GetEnableRoles, { mobile: state.dynamicValidateForm.UserName }).then(res => {
			commit('setEnableRoles', res);
			dispatch('UserExpireNoticeById');
		}).finally(() => { });
	},
	Authenticate({ commit, state, dispatch }) {
		localStorage.removeItem('path');
		localStorage.removeItem('links');
		axios.ajaxPost('post', Api.api.login.Authenticate, state.dynamicValidateForm).then(res => {
			if (res.data) {
				if (res.data.StatusCode == 200) {
					sessionStorage.removeItem("store");
					router.push('/workbench');
					localStorage.setItem('token', res.data.token_type + ' ' + res.data.access_token);
					localStorage.setItem('Version', res.data.profile.version);
					localStorage.setItem('user', JSON.stringify(res.data.profile));
					dispatch('GetEnableRoles');
				}
			}
		})
	},
	UserExpireNoticeById({ commit, state }) {
		axios.ajaxGet('get', Api.api.login.UserExpireNoticeById, { userId: JSON.parse(localStorage.getItem('user')).sid }).then(res => {
			if(res.data && res.data.StatusCode == 1000) {
				MessageBox({
					title: "消息",
					message: `
						<p>
							<span>当前系统服务即将到达使用截止日期，请联系实施/服务/客服人员续期，避免中断。</span>
							<div style="color: red">到期时间：${res.data.Msg}</div>
						</p>
					`,
					dangerouslyUseHTMLString: true,
					showCancelButton: false,
					type: "warning",
					confirmButtonText: "确定"
				});
			}
		}).catch(err => {
			console.log(err,'dddddddddddd')
		})
	},
	ChangeRole({ commit, state, dispatch }) {
		localStorage.removeItem('path');
		localStorage.removeItem('links');
		return axios.ajaxPost('post', Api.api.login.ChangeRole, state.dynamicValidateForm).then(res => {
			if (res.data) {
				if (res.data.StatusCode == 200) {
					sessionStorage.removeItem("store");
					localStorage.setItem('token', res.data.token_type + ' ' + res.data.access_token);
					localStorage.setItem('Version', res.data.profile.version);
					localStorage.setItem('user', JSON.stringify(res.data.profile));
					let permissions = JSON.parse(res.data.profile.permissions);
					dispatch('UserExpireNoticeById');
					commit('changeRouter', permissions)
					commit('setLinks', res.data.profile.permissions)
				}
			}
		}).finally(() => { });
	},
	ChangeRoles({ commit, state, dispatch }, arr) {
		localStorage.removeItem('path');
		localStorage.removeItem('links');
		axios.ajaxGet('get', Api.api.login.GetEnableRoles, { mobile: state.dynamicValidateForm.UserName }).then(res => {
			localStorage.setItem('selectRole', JSON.stringify(res.data.Roles));
			if (!res.data.HasExisted) {
				axios.ajaxPost('post', Api.api.login.register, {
					phone: arr.phone,
					logincode: arr.logincode,
					roleGuid: arr.roleGuid
				}).then(regres => {
					axios.ajaxPost('post', Api.api.login.ChangeRole, {
						Answer: "",
						Captcha: "",
						Password: "",
						RoleId: arr.roleGuid,
						UserName: state.dynamicValidateForm.UserName
					}).then(res => {
						if (res.data.StatusCode == 200) {
							localStorage.removeItem('path');
							localStorage.removeItem('links');
							sessionStorage.removeItem("store");
							let permissions = JSON.parse(res.data.profile.permissions);
							localStorage.setItem('token', res.data.token_type + ' ' + res.data.access_token);
							localStorage.setItem('Version', res.data.profile.version);
							localStorage.setItem('user', JSON.stringify(res.data.profile));
							dispatch('UserExpireNoticeById');
							localStorage.setItem('links', JSON.stringify(permissions));
							state.menuFlag = false;
							state.openeds.push(permissions.KeyName)
							if (permissions[0].children.length > 0) {
								state.permissions = permissions[0].children[0].RoutePath;
								router.push({ path: permissions[0].children[0].RoutePath })
							} else {
								state.permissions = permissions[0].RoutePath;
								router.push({ path: permissions[0].RoutePath })
							}
							commit('setLinks', res.data.profile.permissions)
						}
					})
				})
			} else {
				axios.ajaxPost('post', Api.api.login.ChangeRole, {
					Answer: "",
					Captcha: "",
					Password: "",
					RoleId: res.data.Roles[0].RoleGuid,
					UserName: state.dynamicValidateForm.UserName
				}).then(res => {
					if (res.data.StatusCode == 200) {
						localStorage.removeItem('path');
						localStorage.removeItem('links');
						sessionStorage.removeItem("store");
						let permissions = JSON.parse(res.data.profile.permissions);
						localStorage.setItem('token', res.data.token_type + ' ' + res.data.access_token);
						localStorage.setItem('Version', res.data.profile.version);
						localStorage.setItem('user', JSON.stringify(res.data.profile));
						localStorage.setItem('links', JSON.stringify(permissions));
						dispatch('UserExpireNoticeById');
						state.menuFlag = false;
						state.openeds.push(permissions.KeyName)
						if (permissions[0].children.length > 0) {
							state.permissions = permissions[0].children[0].RoutePath;
							router.push({ path: permissions[0].children[0].RoutePath })
						} else {
							state.permissions = permissions[0].RoutePath;
							router.push({ path: permissions[0].RoutePath })
						}
					}
				})
			}
		});
	},
	register({ commit, state }, arr) {
		return axios.ajaxPost('post', Api.api.login.register, arr).then(res => { }).finally(() => { });
	}
}
export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}
